// extracted by mini-css-extract-plugin
export default {"container":"AccordionCaret_container__5xSa5","up":"AccordionCaret_up__eeSmr"};